import React from 'react'
import { Outlet } from 'react-router-dom'
import DarkMode from '../components/Authentication/DarkMode'

const AuthLayout: React.FC = () => {
  return (
    <>
      <DarkMode />
      <Outlet />
    </>
  )
}

export default AuthLayout

